export default __webpack_public_path__ + "static/media/NTEX SYLLABUS_2026-27 CLASS 7.6b19488b.pdf";